import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-impact-tracker-logo',
  templateUrl: './impact-tracker-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: 'impact-tracker-logo.component.less',
})
export class ImpactTrackerLogoComponent {
  public logoHeading = input.required<string>();
}
